import React from 'react';

/**
 * Service card component for displaying service information
 * @param {Object} props - Component props
 * @param {string} props.icon - Icon name
 * @param {string} props.title - Service title
 * @param {string} props.blurb - Short service description
 * @param {string} [props.href] - Link to service details
 * @returns {React.ReactElement} ServiceCard component
 */
const ServiceCard = ({ icon, title, blurb, href, id }) => {
  // Get the image path for the service
  const getImagePath = () => {
    // Map service IDs to their corresponding image files
    const imageMap = {
      'photography': '/assets/services/aerial-photography.svg',
      'videography': '/assets/services/aerial-videography.svg',
      'mapping': '/assets/services/aerial-mapping.svg',
      'inspections': '/assets/services/inspections.svg'
    };
    
    return imageMap[id] || `/assets/services/${id}.svg`;
  };

  const CardContent = () => (
    <>
      <div className="flex flex-col items-center">
        <img 
          src={getImagePath()} 
          alt={title} 
          className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 lg:w-40 lg:h-40"
        />
      </div>
    </>
  );

  if (href) {
    return (
      <a 
        href={href} 
        className="block p-3 sm:p-4 md:p-6 bg-transparent text-center hover:bg-brand-dark/50 transition-colors duration-300 rounded-lg"
      >
        <CardContent />
      </a>
    );
  }

  return (
    <div className="p-3 sm:p-4 md:p-6 bg-transparent text-center rounded-lg">
      <CardContent />
    </div>
  );
};

export default ServiceCard;
